<template>
  <button
    type="submit"
    class="vs-btn btn d-block btn--outline--white"
    :class="animationState"
  >
    <slot />
  </button>
</template>

<script>

export default {
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      animationState: 'idle',
    };
  },

  computed: {
    buttonState() {
      return this.isLoading ? 'progressing' : 'idle';
    },
  },

  watch: {
    buttonState(newState, oldState) {
      if (newState === 'idle' && oldState === 'progressing') {
        this.$el.addEventListener('animationiteration', () => {
          this.animationState = 'idle';
        }, { once: true });
        return;
      }

      this.animationState = newState;
    },
  },
};
</script>

<style scoped>
button.btn {
  transition: width 0.5s,
              border-radius 0.5s,
              border-color 0.5s,
              transform 0.5s;
  height: 50px;
  white-space: nowrap;
}

.btn.progressing,
.btn.progressing:hover,
.btn.progressing:active {
  background: none;
  border-radius: 60px;
  width: 50px !important;
  color: transparent;
  position: relative;
}
.btn.progressing,
.btn.progressing:hover,
.btn.progressing:active {
  border-color:rgba(255,255,255,0.2);
  border-left-color: white;
  animation-name: rotating;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-delay: 0.5s;
}

.btn.idle {
  position: relative;
  cursor: default;
  animation-name: restore;
  animation-duration: 0.5s;
}
.btn.idle[disabled] {
  opacity: 1;
  border-color: rgba(0,0,0,0);
  height: initial;
}

@keyframes rotating {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
@keyframes restore {
  0% {
    border-radius: 60px;
    width: 50px;
    color: transparent;
    transform: rotate(0deg);
  }
  95% {
    color: white;
  }
  100% {
    border-radius: 0;
    width: 210px;
  }
}
</style>
